import styled from 'styled-components';

import { MiniBadge } from '@xingternal/badge';
import { importComponent } from '@xingternal/hops';
import { mediaConfined } from '@xingternal/layout-tokens';
import { Link } from '@xingternal/link';
import { spaceL, spaceM, spaceXS, xdlColorText } from '@xingternal/tokens';
import { Meta } from '@xingternal/typography';

import { LGapCol, SGapCol } from '../shared.styles';

const ActionButtons = importComponent(
  () => import('../action-buttons'),
  ({ ActionButtons }) => ActionButtons
);

export const Content = styled(SGapCol)`
  width: 100%;
  margin-left: ${spaceM};

  @media ${mediaConfined} {
    gap: ${spaceM};
    margin-left: ${spaceL};
  }
`;

export const ListItem = styled(Link)`
  position: relative;
  display: flex;
  flex-direction: row;
  color: ${xdlColorText};

  &:hover,
  &:focus {
    text-decoration: none;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
`;

export const MobileActionButtons = styled(ActionButtons)`
  margin-left: auto;
  padding-left: ${spaceM};
`;

export const Date = styled(Meta)`
  display: flex;
  align-items: center;

  @media ${mediaConfined} {
    align-self: flex-end;
  }
`;

export const ButtonContainer = styled(LGapCol)`
  flex-shrink: 0;
`;

export const Notification = styled(MiniBadge)`
  margin-right: ${spaceXS};
`;
